export default __webpack_public_path__ + "static/karton3-e3b25f66a836ef799946cde7db1382c8.png";